import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { Link } from 'react-router-dom';
import { ROUTE_NAMES } from '../../Routes';

// import GetInTouchSection from '../../Components/GetInTouchSection';
import StayConnected from '../../Components/StayConnectedSection';

import RightArrow from '../../assets/images/right-arrow.png';

export default function CapitalVenturesServices() {
  const location = useLocation();

  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  return (
    <div className='service-page'>
      <Helmet>
        <title>Starlife: Capital Ventures</title>
        <meta
          name='description'
          content="We align with select capital partners to co-invest in projects with high-growth potential. Whether you're a private investor, family office, or institutional fund, our transparent structure and risk-managed approach make us a trusted investment partner."
        />
        <meta
          name='keywords'
          content='Capital Ventures, Co-investment, High-growth potential, Private investor, Family office, Institutional fund, Transparent structure, Risk-managed approach'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='service-context'>
        <h2 className='service-page-title'>Capital Ventures</h2>
        <p className='service-page-text'>
          We align with select capital partners to co-invest in projects with
          high-growth potential. Whether you're a private investor, family
          office, or institutional fund, our transparent structure and
          risk-managed approach make us a trusted investment partner.
        </p>
      </div>
      <div className='our-services-section'>
        <h2 className='section-title'>Other Services</h2>
        <div className='service-list'>
          <Link to={ROUTE_NAMES.LENDINGSOLUTIONS} className='service-block'>
            <h3>Lending Solutions</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
          <Link
            to={ROUTE_NAMES.EBSERVICE}
            className='service-block green-block'
          >
            <h3>EB-5 & Foreign Capital Consulting</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
        </div>
      </div>
      {/* <GetInTouchSection /> */}
      <StayConnected />
    </div>
  );
}
